import { urlWithParams } from '@marketplace-web/shared/utils'

export const MEMBER_PROFILE_URL = (id: string | number, closetPromotionPrecheckout?: boolean) =>
  urlWithParams(`/member/${id}`, { cp_precheckout: closetPromotionPrecheckout })
export const MEMBER_RESTORE_URL = (id: number): string => `/admin/users/${id}/restore`
export const MEMBER_FOLLOWING_URL = (id: number, page?: number): string =>
  page ? `/member/general/following/${id}?page=${page}` : `/member/general/following/${id}`
export const MEMBER_FOLLOWERS_URL = (id: number, page?: number): string =>
  page ? `/member/general/followers/${id}?page=${page}` : `/member/general/followers/${id}`
export const MEMBER_TEMPLATES_URL = (id: number): string => `/admin/member/${id}/user_msg_templates`

export const ITEM_UPLOAD_URL = '/items/new'
export const ITEM_URL = (id: number): string => `/items/${id}`
export const EDIT_ITEM_URL = (id: number, origin?: string) =>
  `/items/${id}/edit${origin ? `?origin=${origin}` : ''}`
export const PROFILE_SETTINGS_URL = '/settings/profile'
export const NEW_ADMIN_ALERT_URL = '/admin_alert/new'
export const ADMIN_SECTION_PROFILE_PAGE_URL = (userId: number) => `/admin/member/${userId}`
